<template>
  <button
    type="button"
    class="btn btn-sm btn-primary tw-inline-flex tw-items-center"
    @click.stop="open()"
  >
    <icon-carbon-cloud-upload class="tw-mr-1 tw-w-6 tw-h-6" />
    Neues Bild hochladen
  </button>
</template>

<script lang="ts" setup>
import { useFileDialog } from '@vueuse/core'
import { watch } from 'vue'
import type { Image } from '../types'

const props = defineProps<{
  defaultLicenseId: number
}>()
const emit = defineEmits<{
  (e: 'input', value: Image): void
}>()

const { files, open } = useFileDialog({
  multiple: false,
  accept: 'image/*',
  capture: 'environment',
})

watch(files, async () => {
  if (files.value && files.value.length > 0) {
    const file = files.value.item(0)
    if (file) {
      const content = await readFile(file)
      emit('input', newImage(file, content))
    }
  }
})

function readFile(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = function (event) {
      if (event.target) {
        resolve(event.target.result as string)
      }
    }
    reader.readAsDataURL(file)
  })
}

function newImage(file: File, content: string): Image {
  return {
    url: content,
    imageFile: file,
    title: file.name,
    description: '',
    authorName: '',
    licenseId: props.defaultLicenseId,
    originUrl: '',
    isUseExplicitlyGrantedByAuthor: false,
  }
}
</script>
